import React, { ReactElement } from 'react';
import { useShopifyProduct } from '../../../../api/shopify/ShopifyProduct';
import { Gallery } from './gallery/Gallery';
import {
  getBoxedDimensions,
  getBoxedDimensionsSvg,
  getDimensions,
  getDimensionsSvg,
  getEnergyWaterRatingsSvgs,
  getWithStandDimensions,
  getWithStandDimensionsSvg,
  getWithoutStandDimensions,
  getWithoutStandDimensionsSvg,
} from '../utils/utils';
import { DimensionsImage } from '@jbhi-fi/components/src/DimensionsImage/DimensionsImage';

export const Images = (): JSX.Element => {
  const { shopify, metafields } = useShopifyProduct();
  const productGroupId = metafields?.online_product?.value?.ProductGroup?.Id;
  const { waterRatingSrc, energyRatingSrc, comboEnergyRatingSrcs } = getEnergyWaterRatingsSvgs(metafields);
  const sortedImages: Array<string | ReactElement> = shopify.images.filter(image => !image.includes('Embedded'));
  if (energyRatingSrc) {
    sortedImages.push(energyRatingSrc);
  }
  if (waterRatingSrc) {
    sortedImages.push(waterRatingSrc);
  }
  if (productGroupId === 863 && comboEnergyRatingSrcs) {
    sortedImages.push(...comboEnergyRatingSrcs);
  }

  const view = sortedImages.length > 1 ? 'gallery' : 'grid';

  const shouldShowDimensionImages = window.Jbhifi.dimensionsProductGroupIds.includes(productGroupId?.toString());
  if (shouldShowDimensionImages) {
    const dimensions = getDimensions(metafields);
    const boxedDimensions = getBoxedDimensions(metafields);
    const withStandDimensions = getWithStandDimensions(metafields);
    const withoutStandDimensions = getWithoutStandDimensions(metafields);

    const dimensionsSvg = dimensions && (
      <DimensionsImage
        src={getDimensionsSvg(productGroupId)}
        width={dimensions.width ?? ''}
        height={dimensions.height ?? ''}
        depth={dimensions.depth ?? ''}
      />
    );
    const boxedDimensionsSvg = boxedDimensions && (
      <DimensionsImage
        src={getBoxedDimensionsSvg(productGroupId)}
        width={boxedDimensions.width ?? ''}
        height={boxedDimensions.height ?? ''}
        depth={boxedDimensions.depth ?? ''}
        weight={boxedDimensions.weight ?? ''}
      />
    );

    const withStandDimensionsSvg = withStandDimensions && (
      <DimensionsImage
        title="Product with stand"
        src={getWithStandDimensionsSvg(productGroupId)}
        width={withStandDimensions.width ?? ''}
        height={withStandDimensions.height ?? ''}
        depth={withStandDimensions.depth ?? ''}
        weight={withStandDimensions.weight ?? ''}
      />
    );

    const withoutStandDimensionsSvg = withoutStandDimensions && (
      <DimensionsImage
        title="Product without stand"
        src={getWithoutStandDimensionsSvg(productGroupId)}
        width={withoutStandDimensions.width ?? ''}
        height={withoutStandDimensions.height ?? ''}
        depth={withoutStandDimensions.depth ?? ''}
        weight={withoutStandDimensions.weight ?? ''}
      />
    );

    if (dimensions && dimensionsSvg) {
      sortedImages.push(dimensionsSvg);
    }
    if (withStandDimensions && withStandDimensionsSvg) {
      sortedImages.push(withStandDimensionsSvg);
    }
    if (withoutStandDimensions && withoutStandDimensionsSvg) {
      sortedImages.push(withoutStandDimensionsSvg);
    }
    if (boxedDimensions && boxedDimensionsSvg) {
      sortedImages.push(boxedDimensionsSvg);
    }
  }

  return (
    <>
      <Gallery view={view} images={sortedImages} title={shopify.title} />
    </>
  );
};
